module.exports = __webpack_public_path__ + "static/media/icon-reports.9ab34b7e.svg";